// extracted by mini-css-extract-plugin
export var storyRowWrapperCenter = "x_sP d_bD";
export var storyRowWrapper = "x_hx d_hx d_bK";
export var storyLeftWrapper = "x_sQ d_bz d_bP";
export var storyWrapperFull = "x_sR d_cD";
export var storyWrapperFullLeft = "x_pl d_cD d_bz d_bP d_bD";
export var contentWrapper = "x_mv d_hy";
export var storyLeftWrapperCenter = "x_sS d_hz d_bz d_bD d_bP d_bJ";
export var storyRightWrapperCenter = "x_sT d_hF";
export var storyHeader = "x_sV d_hD d_w d_cs";
export var storyHeaderCenter = "x_hC d_hC d_w d_cs d_dw d_by";
export var storyParagraphCenter = "x_hB d_hB d_by d_dw";
export var storyBtnWrapper = "x_sW d_d2 d_d1 d_w d_bz d_bG";
export var storyBtnWrapperCenter = "x_hJ d_hJ d_d1 d_w d_bz d_bD";
export var imageWrapper = "x_sM d_fg d_Z";
export var imageWrapperFull = "x_sX d_w d_H d_bf d_Z";
export var SubtitleSmall = "x_qd q_qd q_qr q_qD";
export var SubtitleNormal = "x_qf q_qf q_qr q_qF";
export var SubtitleLarge = "x_qg q_qg q_qr q_qG";
export var textLeft = "x_dv";
export var textCenter = "x_dw";
export var textRight = "x_dx";